import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Spin } from 'antd';
import * as S from './Styled';

const defaultProps = {
  size: 'small',
};

const propTypes = {
  size: PropTypes.string,
  flow: PropTypes.string,
};

const Spinner = ({ size, flow, margin, children, ...props }) => {
  return (
    <S.Spinner flow={flow} margin={margin} {...props}>
      <Spin size={size} {...props}>
        {children && children}
      </Spin>
    </S.Spinner>
  );
};

Spinner.defaultProps = defaultProps;

Spinner.propTypes = propTypes;

export default Spinner;
